import { Injectable } from '@angular/core'

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  ApiService,
} from '../api/api.service'

@Injectable()
export class PublicLinkService {
  constructor(
    private apiService: ApiService
  ) {}

  exists(uuid) {
    return this.apiService
      .load(`/public_links/${uuid}/exists`, { skipLoader: true })
  }

  load(uuid) {
    return this.apiService
      .load(`/public_links/${uuid}/show_internally`, { skipLoader: true, throwErrors: true })
  }

  update(uuid: string, payload: any, password?: string): any {
    return this.apiService
      .update(`/public_links/${uuid}`, { payload, password }, { skipLoader: true });
  }

  create(payload, uuid, redirectUrl) {
    return this.apiService
      .create(`/public_links`, {
        uuid: uuid,
        redirect_url: redirectUrl,
        payload: payload
      })
  }

  uuid() {
    return this.apiService
      .load(`/public_links/uuid`)
  }

  delete(uuid) {
    return this.apiService
      .delete(`/public_links/${uuid}`)
  }

  verifyPassword(uuid: string, password: string): Observable<{ success: boolean }> {
    return this.apiService.create(`/public_links/${uuid}/verify_password`, { password }, { skipLoader: true, throwErrors: true });
  }

  checkPasswordRequired(uuid): Observable<{ passwordRequired: boolean, uuid: string }> {
    return this.apiService
      .load(`/public_links/${uuid}/check_password_required`, { skipLoader: true, throwErrors: true })
      .pipe(
        map((response: any) => ({
          passwordRequired: response.password_required,
          uuid: response.uuid,
        })),
      );
  }
}
